import { render, staticRenderFns } from "./WidgetFilterForm.vue?vue&type=template&id=0bcb8e3a"
import script from "./WidgetFilterForm.vue?vue&type=script&lang=js"
export * from "./WidgetFilterForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetFilterForm.vue?vue&type=style&index=0&id=0bcb8e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports